import { render, staticRenderFns } from "./account_setting.vue?vue&type=template&id=381fb592&scoped=true&"
import script from "./account_setting.vue?vue&type=script&lang=js&"
export * from "./account_setting.vue?vue&type=script&lang=js&"
import style0 from "./account_setting.vue?vue&type=style&index=0&id=381fb592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381fb592",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
